<template>
  <div class="warp">
    <router-view/>
    <van-tabbar style="z-index: 999" :safe-area-inset-bottom="state" route v-model="active" active-color="#2D6EFE"
                inactive-color="#CFCFD8">
      <van-tabbar-item
        replace
        to="/homeView"
      >
        <span>首页</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? icon.home : icon.homeInactive"
        >
      </van-tabbar-item>
      <van-tabbar-item
        replace
        to="/message"
      >
        <span>消息</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? icon.message2 : icon.message1"
        >
      </van-tabbar-item>
<!--      <van-tabbar-item-->
<!--      >-->
<!--        <div class="RichScanDiv" @click="richScan()">-->
<!--          <img src="../assets/images/warp/sys.png"/>-->
<!--        </div>-->
<!--      </van-tabbar-item>-->
      <van-tabbar-item
        replace
        to="/task-management2"
      >
        <span>协同</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? icon.xt2 : icon.xt1"
        >
      </van-tabbar-item>
      <van-tabbar-item
        replace
        to="/mePage"
      >
        <span>我的</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? icon.wd1 : icon.wd2"
        >
      </van-tabbar-item>
    </van-tabbar>
    <van-overlay :show="abutmentDetailShow" >
      <div class="wrapper">
        <div class="block"
             >
          <div class="close" @click="abutmentDetailShow = false">
            <i class="iconfont iconguanbi"/>
          </div>
          <div @click.stop="abutmentDetailClick(item.id)"
               style="border-bottom: 1px solid rgba(22, 190, 154,1);"
               v-for="(item,index) in abutmentDetailList" :key="item.id">
            {{item.precastBeamName}}
          </div><br/>
        </div>
      </div>
    </van-overlay>
    <!--<cms-sys />-->
  </div>
</template>

<script>
export default {
  name: 'warp',
  data () {
    return {
      state:true,
      active: 0,
      icon: {
        home: require('../../static/images/warp/zy1.png'),
        homeInactive: require('../../static/images/warp/zy2.png'),
        sc1: require('../../static/images/warp/sc1.png'),

        sc2: require('../../static/images/warp/sc2.png'),

        sg1: require('../../static/images/warp/sg1.png'),
        sg2: require('../../static/images/warp/sg2.png'),

        wd1: require('../../static/images/warp/wd1.png'),
        wd2: require('../../static/images/warp/wd2.png'),

        message1: require('../../static/images/warp/message1.png'),
        message2: require('../../static/images/warp/message2.png'),

        xt1: require('../../static/images/warp/xt1.png'),
        xt2: require('../../static/images/warp/xt2.png'),
      },
      abutmentDetailShow:false,  // 扫一扫台座 弹框 状态
      abutmentDetailList:[],  // 扫一扫台座
    }
  },
  mounted() {
  },
  methods: {
    richScan(){
      // this.$bus.$emit('cmsSys')
      this.$goRoute('showVideo')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import "warp.less";
</style>



// WEBPACK FOOTER //
// src/components/wrap.vue